import React, { useState } from 'react';
import { Typography, useTheme, Box } from '@mui/material';
import ErrorCard from '../ErrorCard/ErrorCard';
import LinkClickResponse from '../../../types/Analytics/LinkClickResponse';
import CustomTooltip from '../../../components/CustomTooltip/CustomTooltip';
import styles from './styles';

interface TopLinksProps {
  linksData?: LinkClickResponse[];
  isSmallScreen?: boolean;
}

function TopLinks({
  linksData,
  isSmallScreen
}: TopLinksProps): React.ReactElement | null {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const theme = useTheme();

  const truncateUrl = (url: string, maxLength: number = 120): string => {
    return url.length > maxLength ? `${url.slice(0, maxLength)}...` : url;
  };

  if (errorMessage) {
    return <ErrorCard errorMessage={errorMessage} />;
  }

  if (!linksData) {
    return null;
  }

  return (
    <Box sx={styles.outerContainer}>
      {linksData.length < 1 ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }}
        >
          <Typography variant='body2' sx={{ textAlign: 'center' }}>
            No links have been clicked during this date range.
          </Typography>
        </Box>
      ) : (
        <Box sx={styles.innerContainer}>
          {linksData.map((link, index) => (
            <Box key={index} sx={styles.listItem}>
              <Box sx={styles.urlContainer}>
                <CustomTooltip content={link.url}>
                  <a
                    href={link.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={styles.url as React.CSSProperties}
                  >
                    {truncateUrl(link.url)}
                  </a>
                </CustomTooltip>
              </Box>
              <Typography sx={styles.clicksText}>
                {link.totalClicks} clicks
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default TopLinks;
